import { assert } from '@varos/util-typescript';
import { ReportingShellLoaderBaseConfig } from '../../../base';
import { ReportingShellContextLoader } from './reportingContextInterface';
import { useMemo } from 'react';
import { ReportingShellContextAggregate } from './reportingContextModel';

export function createReportingContextLoader(
    config: ReportingShellLoaderBaseConfig
): ReportingShellContextLoader {
    return {
        useLoad(props): ReportingShellContextAggregate {
            const auth = config.hook.useAuth();
            const account = config.hook.useAccount();
            assert(auth.user?.id, 'missing user id');
            const workspaceQuery = config.repository.platform.workspace.useDefault(
                {
                    principal: {
                        kind: 'user',
                        id: auth.user.id,
                        account: account.id,
                    },
                    organization: null,
                    token: 'NOT SUPPORTED',
                },
                {},
                {
                    suspense: true,
                }
            );
            assert(workspaceQuery.status === 'success', 'expected suspense');
            return {
                workspace: workspaceQuery.data,
            };
        },
    };
}
